export default {
  'menu.customizations.title': '附加选项',
  'menu.customizations.groups': '附加选项组 ({count}项)',
  'menu.customizations.options': '附加选项 ({count}项)',
  'menu.customizations.dishPreferences': '三级菜单({count}项)',
  'menu.customizations.group.required': '必选',
  'menu.customizations.group.maxSelections': '最多可选{maxCount}个选项',
  'menu.customizations.action.add': '新增附加选项',

  'menu.customizations.edit.title': '编辑附加选项',
  'menu.customizations.add.title': '新增附加选项',
  'menu.customizations.section.details': '附加选项组',
  'menu.customizations.section.options': '选项',
  'menu.customizations.option.title': '选项{index}',
  'menu.customizations.column.name': '名称',
  'menu.customizations.column.foreignName': '中文名',
  'menu.customizations.column.code': '自定义码',
  'menu.customizations.column.required': '必选',
  'menu.customizations.column.minSelections': '最少选项数',
  'menu.customizations.errors.minSelectionsLessOrEqualThanMaxQuantities': '最少选项数必须小于等于最多可选份数。',
  'menu.customizations.errors.minSelectionsLessOrEqualThanMinQuantities': '最少选项数必须小于等于最少可选份数。',
  'menu.customizations.column.minQuantities': '最少可选份数',
  'menu.customizations.errors.maxQuantitiesGreatOrEqualThanMinQuantities': '最多可选数不能小于最少可选数。',
  'menu.customizations.column.maxSelections': '最多选项数',
  'menu.customizations.column.maxQuantities': '最多可选份数',
  'menu.customizations.errors.maxSelectionsGreatOrEqualThanMinSelections': '最多选项数不能小于最少选项份数。',
  'menu.customizations.errors.maxSelectionsLessOrEqualThanMaxQuantities': '最多选项数不能大于最多可选份数。',
  'menu.customizations.column.maxQuantitiesPerOption': '每项最大可选数',
  'menu.customizations.errors.maxQuantitiesPerOptionLessOrEqualThanMaxQuantities':
    '每项最大可选数不能大于最多可选份数。',
  'menu.customizations.option.column.name': '名称',
  'menu.customizations.option.column.foreignName': '中文名',
  'menu.customizations.option.column.price': '价格',
  'menu.customizations.option.column.groupName': '菜品搭配组',
  'menu.customizations.option.column.status': '状态',
  'menu.customizations.option.column.quota': '库存',
  'menu.customizations.option.column.isDefault': '默认项',
  'menu.customizations.option.column.defaultQuantity': '默认数量',
  'menu.customizations.option.column.code': '自定义码',
  'menu.customizations.option.isDefault': '(默认项)',
  'menu.customizations.option.defaultQuantity': '默认数量:{defaultQuantity}',
  'menu.customizations.selectionsRestrictions': '选项限制',
  'menu.customizations.quantityRestrictions': '份数限制',
  'menu.customizations.maxQuantitiesPerSection': '每项最多可选份数',
  'menu.customizations.minRestriction': '最少',
  'menu.customizations.maxRestriction': '最多',
  'menu.customizations.relatedDishes': '关联的菜品 ({dishCount})',

  'menu.customizations.column.name.required': '选项组名称必填',
  'menu.customizations.column.foreignName.required': '选项组中文名必填',
  'menu.customizations.option.name.required': '选项名必填',
  'menu.customizations.option.name.existed': '选项名已存在',
  'menu.customizations.option.foreign_name.required': '选项中文名必填',
  'menu.customizations.option.foreign_name.existed': '选项中文名已存在',
  'menu.customizations.column.defaultQuantity.required': '默认数量必填',
  'menu.customizations.option.defaultQuantity.exceedMaximum': '超过每项最大可选份数',
  'menu.customizations.option.selected.exceedMaximum': '超过最多选项数',
  'menu.customizations.option.totalQuantity.exceedMaximum':
    '当前总默认数量:{selectedQuantity}, 超过最大可选数:{maxSelectedQuantity}',

  'menu.customizations.option.action.add': '添加新选项',
  'menu.customizations.option.action.addPreferences': '添加偏好',

  'menu.customizations.options.count': '{count}项',
  'menu.customizations.removePrompt': '确认要删除此附加选项组吗？',
  'menu.customizations.cannot.removePrompt': '当前选项组已设置在配方中，暂不能删除',
  'menu.customizations.cannot.removePrompt.description': '请首先在配方中取消该选项组',
  'menu.customizations.cannot.removePrompt.gotcha': '知道了！',
  'menu.customizations.option.column.posName': 'POS别名',
  'menu.customizations.option.column.kitchenName': '后厨别名',
  'menu.customizations.option.column.posName.placeholder': '点餐页上展示的名字',
  'menu.customizations.option.column.kitchenName.placeholder': '在后厨单和标签上展示的名字',
  'menu.customizations.option.column.posName.tooltip': '别名可以是短名或缩写，区分大小写，并在点餐页上展示的名字',
  'menu.customizations.option.column.kitchenName.tooltip':
    '别名可以是短名或缩写，区分大小写，并在后厨单和标签上展示的名字',
  'menu.customizations.preference.title': '偏好',
  'menu.customizations.action.choosePreferenceCategories': '选择偏好',
  'menu.customizations.totalCount': '<b>总共:</b> {totalCount}项',
  'menu.customizations.searchPlaceholder': '搜索附加选项组或选项',
  'menu.customizations.searchResultSummary': '搜索',
  'menu.customizations.matchedCount': '({matchedCount}个匹配项)',
  'menu.customizations.chooseOption': '选择附加选项',
  'menu.customizations.selectedOptions': '已选择选项:',
  'menu.customizations.selectedDishes': '已选择菜品:',
  'menu.customizations.loadCustomizationDetailFailed': '加载附加选项详情失败，点击重试',
  'menu.customizations.loadCustomizationListFailed': '加载附加选项列表失败，点击重试',
  'menu.customizations.searchCustomizationFailed': '搜索附加选项失败, 点击重试',
  'menu.customizations.emptySearchTerm': '请输入任何搜索词以查找附加选项。',
  'menu.customizations.emptySearchResult': '没有附加选项符合您的搜索条件。请更新您的搜索词以查找附加选项。',
  'menu.customizations.restaurantSide': '商家端',
  'menu.customizations.customerSide': '顾客端',
  'menu.customizations.restaurantGuide': `
      <p>
        我们的菜单管理使附加项的使用变得简单、直观，每一个附加项都能独立编辑。
      </p>
      <p>
        保障您的顾客能够轻松地个性化点餐——无论是选择尺寸，添加配料，还是更换配料。
      </p>
      <p>
        通过提供一系列的选项，不仅提升了顾客的点餐体验，同时让您的员工快速准确地处理订单，提供快捷、高效的服务。
      </p>
    `,
  'menu.customizations.customerGuide': `
    <p>
      根据自己的饮食习惯，顾客可选择想要的口味、配料。
    </p>
    <p>
      点奶茶变得轻而易举——只需点击几下即可选择温度、大小、糖含量和配料。
    </p>
    <p>
      简化的流程确保顾客能快速选择心仪的味道，下单体验快速轻松。
    </p>
  `,
  'menu.customizations.noRelatedDishes': '暂未关联任何菜品',
  'menu.customizations.selectionRestrictionsDescription': `比如选项有蛋黄酱、黄芥末酱、沙拉酱、洋葱甜酱、烧烤酱、蕃茄酱共6种可选项，但限制其中最少选择2种、最多选择4种。`,
  'menu.customizations.quantityRestrictionsDescription': `比如选项有牛肉、鸡肉、洋葱、辣椒、番茄、黄瓜等配料可选，不论选择什么、不论选择是否重复，最少选择2份、最多选择4份。`,
  'menu.customizations.maxQuantityPerOptionDescription': `比如有多种可选项，每一种选项，最多可以选择2份。`,
  'menu.customizations.nameConflicts': '选项{rowIndexes}的名称冲突',
  'menu.customizations.foreignNameConflicts': '选项{rowIndexes}的中文名冲突',
};
